import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import WhiteScreen from './pages/WhiteScreen';
import BlackScreen from './pages/BlackScreen';
import RedScreen from './pages/RedScreen';
import GreenScreen from './pages/GreenScreen';
import BlueScreen from './pages/BlueScreen';
import YellowScreen from './pages/YellowScreen';
import PurpleScreen from './pages/PurpleScreen';
import OrangeScreen from './pages/OrangeScreen';
import PinkScreen from './pages/PinkScreen';
import WhiteNoise from './pages/WhiteNoise';
import About from './pages/About';
import Contact from './pages/Contact';
import './index.css';

function ScrollTop() {
  const { pathname } = require('react-router-dom').useLocation();
  React.useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

export default function App() {
  return (
    <Router>
      <ScrollTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<WhiteScreen />} />
        <Route path="/black-screen" element={<BlackScreen />} />
        <Route path="/red-screen" element={<RedScreen />} />
        <Route path="/green-screen" element={<GreenScreen />} />
        <Route path="/blue-screen" element={<BlueScreen />} />
        <Route path="/yellow-screen" element={<YellowScreen />} />
        <Route path="/purple-screen" element={<PurpleScreen />} />
        <Route path="/orange-screen" element={<OrangeScreen />} />
        <Route path="/pink-screen" element={<PinkScreen />} />
        <Route path="/white-noise" element={<WhiteNoise />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
    </Router>
  );
}

function Privacy() {
  return (
    <main style={{ paddingTop: '60px', minHeight: '80vh' }}>
      <div className="container" style={{ padding: '64px 24px', maxWidth: '760px' }}>
        <h1 style={{ marginBottom: '24px' }}>Privacy Policy</h1>
        <p style={{ color: 'var(--text-muted)', lineHeight: '1.8', marginBottom: '14px' }}>Last updated: January 1, 2025. WhiteScreen is committed to protecting your privacy. This page explains how we handle data when you use our service.</p>
        <h2 style={{ fontSize: '1.2rem', margin: '28px 0 10px' }}>Data We Collect</h2>
        <p style={{ color: 'var(--text-muted)', lineHeight: '1.8', marginBottom: '14px' }}>We collect only anonymous analytics (page views, device type, geographic region) to understand usage patterns. We do not collect personally identifiable information during normal tool use. Contact form submissions are stored only to respond to your inquiry.</p>
        <h2 style={{ fontSize: '1.2rem', margin: '28px 0 10px' }}>What We Do NOT Collect</h2>
        <p style={{ color: 'var(--text-muted)', lineHeight: '1.8', marginBottom: '14px' }}>Your color choices, screen sessions, audio selections, cursor movements, and fullscreen usage are never logged or transmitted. All tool interactions happen entirely within your browser.</p>
        <h2 style={{ fontSize: '1.2rem', margin: '28px 0 10px' }}>Cookies</h2>
        <p style={{ color: 'var(--text-muted)', lineHeight: '1.8', marginBottom: '14px' }}>We use minimal session cookies for basic functionality. We do not use advertising cookies or cross-site tracking pixels. You can disable cookies in your browser settings.</p>
        <h2 style={{ fontSize: '1.2rem', margin: '28px 0 10px' }}>Contact</h2>
        <p style={{ color: 'var(--text-muted)', lineHeight: '1.8' }}>For privacy questions, please use our <a href="/contact" style={{ color: 'var(--primary)' }}>Contact page</a>.</p>
      </div>
    </main>
  );
}

function Terms() {
  return (
    <main style={{ paddingTop: '60px', minHeight: '80vh' }}>
      <div className="container" style={{ padding: '64px 24px', maxWidth: '760px' }}>
        <h1 style={{ marginBottom: '24px' }}>Terms of Service</h1>
        <p style={{ color: 'var(--text-muted)', lineHeight: '1.8', marginBottom: '14px' }}>Last updated: January 1, 2025. By using WhiteScreen, you agree to these terms.</p>
        <h2 style={{ fontSize: '1.2rem', margin: '28px 0 10px' }}>Use of Service</h2>
        <p style={{ color: 'var(--text-muted)', lineHeight: '1.8', marginBottom: '14px' }}>WhiteScreen is provided free of charge for personal, educational, and commercial use. You may use our tools without restriction. We reserve the right to modify or discontinue the service at any time.</p>
        <h2 style={{ fontSize: '1.2rem', margin: '28px 0 10px' }}>Disclaimer</h2>
        <p style={{ color: 'var(--text-muted)', lineHeight: '1.8', marginBottom: '14px' }}>WhiteScreen is provided "as is" without warranty of any kind. We are not responsible for any damage to displays, devices, or equipment resulting from use of our tools. Users are responsible for setting appropriate brightness levels for their specific hardware.</p>
        <h2 style={{ fontSize: '1.2rem', margin: '28px 0 10px' }}>Contact</h2>
        <p style={{ color: 'var(--text-muted)', lineHeight: '1.8' }}>Questions about these terms? <a href="/contact" style={{ color: 'var(--primary)' }}>Contact us</a>.</p>
      </div>
    </main>
  );
}

function NotFound() {
  return (
    <main style={{ paddingTop: '60px', minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}>
      <div>
        <div style={{ fontSize: '4rem', marginBottom: '16px' }}>⬜</div>
        <h1 style={{ fontSize: '2rem', marginBottom: '12px' }}>404 — Page Not Found</h1>
        <p style={{ color: 'var(--text-muted)', marginBottom: '24px' }}>The page you're looking for doesn't exist.</p>
        <a href="/" style={{ background: 'var(--primary)', color: '#fff', padding: '12px 24px', borderRadius: '9px', fontWeight: '700', fontSize: '0.95rem', textDecoration: 'none' }}>← Back to Home</a>
      </div>
    </main>
  );
}
